import React from "react";
import { IJourneyLevel } from "./types";
import styles from "./styles";
import LottieWebPlayer from "./LottieWebPlayer";
import WebShadowButton from "../WebStoryScreen/Components/WebShadowButton";

const storyBookImg = require("./assets/images/storyBook.png");
const closeWhiteJson = require("./assets/jsons/closeWhite.json");

interface StoryModalProps {
  selectedStory: IJourneyLevel;
  onClose: () => void;
  onContinue: () => void;
  audioUri?: string;
}

const StoryModal: React.FC<StoryModalProps> = ({
  selectedStory,
  onClose,
  onContinue,
  audioUri,
}) => {
  console.log(audioUri, "audioUriaudioUriaudioUri");
  return (
    <div style={{ ...styles.modalOverlay, position: "fixed" }}>
      {/* Close button — anchored to top-right of the full overlay */}
      <button style={styles.modalCloseBtn} onClick={onClose} aria-label="Close">
        <LottieWebPlayer
          source={closeWhiteJson}
          style={{ width: 46, height: 46 }}
          autoPlay
          loop={false}
        />
      </button>

      {/* Centred column: book → continue */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 32,
        }}
      >
        {/* Story book */}
        <div style={styles.storyBookWrapper}>
          <img
            src={storyBookImg}
            alt="story book"
            style={styles.storyBookImg}
          />
          <span style={styles.storyBookTitle}>{selectedStory?.name}</span>
        </div>

        {audioUri && (
          <audio src={audioUri} autoPlay style={{ display: "none" }} />
        )}
        <WebShadowButton
          style={{ width: "60%" }}
          title={"Continue"}
          onPress={onContinue}
        />
        {/* <button style={styles.continueBtn} onClick={onContinue}>
          Continue
        </button> */}
      </div>
    </div>
  );
};

export default StoryModal;
